import React from 'react';
import { Row, Col, Form, Select } from 'antd';
import Input from '../../ui/Input'
import './index.css'

const FormItem = Form.Item;
const Option = Select.Option;

interface propsTypes {
    detailData: object | any,
    form: any,
    setValidateCount: any
}

const GeneralGeneralEdit = (props: propsTypes) => {
    
    return (
        <div>
            {/* use always the form tag to inheritace the ant styles */}
            <Form layout='vertical' form={props.form}>
            <Row gutter={24} className="row-margin">
                <Col span={6}>
                    <FormItem name="certavail" label="Certification Available" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span={6} >
                    <FormItem name="linenreuse" label="Linen Reuse Program" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span={6} >
                    <FormItem name="accomodateschemicalall" label="Accommodates Chemical Allergies" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <FormItem name="envfriendlycleaners" label="Environmental Friendly Cleaners" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span={6} >
                    <FormItem name="procurementpolicy" label="Procurement Policy" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span={6} >
                    <FormItem name="certthirdpartyaudits" label="Certification Include Third Party Audits" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <FormItem name="certuponrequest" label="Certification Upon Request" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span={6} >
                    <FormItem name="corporatesocialrespprog" label="Corporate Social Responsibility Program" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={12} >
                    <FormItem
                        extra={<span className="blue-font">If choose Y for Corporate Social Responsibility Program, please explain here (100 characters max)</span>}
                        name="corporatesocialrespprogdesc"
                        label="Corporate Social Responsibility Program Description"
                        rules={[{ max: 100, message: 'You have reached the max character length of 100' }]}
                    >
                        <Input maxLength={100}/>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <FormItem name="noncarbonemittingmethods" label="Non-Carbon Emitting Measures" >
                        <Select allowClear showSearch>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={12} >
                    <FormItem
                        extra={<span className="blue-font">If choose Y for Non-Carbon Emitting Measures, please explain here (150 characters max)</span>}
                        name="noncarbonemittingmethodsdesc"
                        label="Non-Carbon Emitting Measures Description"
                        rules={[
                            { max: 150, message: 'You have reached the max character length of 150' }
                        ]}>
                        <Input maxLength={150}/>
                    </FormItem>
                </Col>
            </Row>
            </Form>
        </div>
    )
}

export default GeneralGeneralEdit;

